module.exports = __webpack_public_path__ + "static/media/avatar_7.750246ab.svg";